'use strict';
import * as $j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$0024 from "./app.data.-Documentary-Credit-Data$package$-Documentary-Credit-Number$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$() {
  this.aB2 = null;
  this.aBf = null;
  this.aB7 = null;
  this.aB8 = false;
  this.aBd = null;
  this.aBe = false;
  this.aB3 = null;
  this.aB4 = false;
  this.aBb = null;
  this.aBc = false;
  this.aB9 = null;
  this.aBa = false;
  this.aB5 = null;
  this.aB6 = false;
  $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ = this;
  this.aB2 = $j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$0024.$m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$();
  this.aBf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$0024.$m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumber$());
}
export { $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ as $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ };
$p = $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$;
/** @constructor */
function $h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$() {
}
export { $h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ as $h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ };
$h_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aB2;
});
$p.eO = (function() {
  return this.aBf;
});
$p.b9 = (function() {
  if ((!this.aB8)) {
    this.aB7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aB8 = true;
  }
  return this.aB7;
});
$p.b3 = (function() {
  if ((!this.aBe)) {
    this.aBd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aBe = true;
  }
  return this.aBd;
});
$p.aG = (function() {
  if ((!this.aB4)) {
    this.aB3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aB4 = true;
  }
  return this.aB3;
});
$p.az = (function() {
  if ((!this.aBc)) {
    this.aBb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aBc = true;
  }
  return this.aBb;
});
$p.aY = (function() {
  if ((!this.aBa)) {
    this.aB9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aBa = true;
  }
  return this.aB9;
});
$p.bN4 = (function() {
  if ((!this.aB6)) {
    this.aB5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "DC Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aB6 = true;
  }
  return this.aB5;
});
var $d_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$, "app.data.DocumentaryCreditData$package$DocumentaryCreditNumberForm$", ({
  Dy: 1,
  N: 1
}));
export { $d_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ as $d_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ };
var $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$;
function $m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$() {
  if ((!$n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$)) {
    $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ = new $c_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$();
  }
  return $n_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$;
}
export { $m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ as $m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$ };
//# sourceMappingURL=app.data.-Documentary-Credit-Data$package$-Documentary-Credit-Number-Form$.js.map
